jQuery(document).ready(function ($) {

  $('.featured-product .product__media-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: true
  });

  $(window).on('resize', function () {
    $('.featured-product .product__media-list').slick('setPosition');
  });

});


jQuery(document).ready(function(){
  jQuery('.custom-faq .faq-question').on('click', function(){
    var item = $(this).closest('.faq-item');

    if(item.hasClass('active')){
      item.removeClass('active');
      item.find('.faq-answer').stop(true,true).slideUp(300);
    } else {

      jQuery('.custom-faq .faq-item').removeClass('active');
      jQuery('.custom-faq .faq-answer').stop(true,true).slideUp(300);

      item.addClass('active');
      item.find('.faq-answer').stop(true,true).slideDown(300);
    }
  });
});

jQuery(document).ready(function ($) {

  $('.readmore-wrapper').each(function () {

    const content = $(this).find('.readmore-content');

    if (!content.length) return;

    if (content[0].scrollHeight <= content[0].clientHeight) {
      $(this).find('.readmore-toggle').hide();
    }

  });

  $(document).on('click', '.readmore-toggle', function () {

    const wrapper = $(this).closest('.readmore-wrapper');
    const content = wrapper.find('.readmore-content');

    content.toggleClass('expanded');

    $(this).text(
      content.hasClass('expanded') ? 'Read Less' : 'Read More'
    );

  });

});


jQuery(document).ready(function ($) {

  $('.category-btn').on('click', function (e) {
    e.stopPropagation();

    var $menu = $(this).next('.collection-list.collection-menu');

    $('.collection-list.collection-menu').not($menu).slideUp(300);
    $('.category-btn').not(this).removeClass('active');

    $menu.slideToggle(300);
    $(this).toggleClass('active');
  });

  // Dropdown ni andar click karo to bandh nai thay
  $('.collection-list.collection-menu').on('click', function (e) {
    e.stopPropagation();
  });

  // Bahar click karo etle dropdown bandh thai jase
  $(document).on('click', function () {
    $('.collection-list.collection-menu').slideUp(300);
    $('.category-btn').removeClass('active');
  });

});



jQuery('.benefit-item').on('click', function () {

  let tab = $(this).data('tab');

  $('.benefit-item').removeClass('active');
  $(this).addClass('active');

  $('.tab-images').removeClass('active');
  $('.tab-images[data-tab="' + tab + '"]').addClass('active');

  $('.tab-slider').removeClass('active');
  $('.tab-slider[data-tab="' + tab + '"]').addClass('active');

  setTimeout(function() {
    window.dispatchEvent(new Event('resize'));
  }, 100);

});



document.addEventListener('click', function(e) {
    if (e.target.closest('.search-box')) {
        const details = document.querySelector('.header__icons .header__search details');
        if (details) {
            details.setAttribute('open', '');
        }
    }
});